import { queryOptions } from "@tanstack/react-query";

import { getSurveyDetails } from "@/modules/session-survey/services/getSurveyDetails";
import { isFetchNetworkError } from "@/modules/shared/utils/reactQueryErrorTracking";

export const sessionSurveyKeys = {
  root: ["session-survey"] as const,
  details: (surveyId: string) =>
    [...sessionSurveyKeys.root, "details", surveyId] as const,
};

export const surveyDetailsQuery = (
  surveyId: string,
  loadDetails = getSurveyDetails,
) =>
  queryOptions({
    queryKey: sessionSurveyKeys.details(surveyId),
    queryFn: () => loadDetails(surveyId),
    staleTime: 0,
    networkMode: "always",
    retry: (failureCount, error) =>
      failureCount < 2 && isFetchNetworkError(error),
    retryDelay: (attempt) => 1000 * 2 ** attempt,
  });
